module.exports = __webpack_public_path__ + "img/sp_logo@2x.70b1f6e4.png";